import { History, HistoryCreateInput, HistoryResponse } from '@repo/types';
import { AxiosInstance } from 'axios';
import { axiosInstance } from '../axios-instance';
import { ENDPOINTS } from '../endpoint';
import { BaseApiService } from './base-api.service';

interface HistoryListResponse {
  data: History[];
  total: number;
  message?: string;
}

export class HistoryService extends BaseApiService {
  constructor(axios: AxiosInstance = axiosInstance) {
    super(ENDPOINTS.HISTORY.BASE, axios);
  }

  /**
   * Get history by inventaire ID (returns last 3 records)
   */
  async getHistoryByInventaireId(inventaireId: number): Promise<HistoryListResponse> {
    return this.get<HistoryListResponse>(ENDPOINTS.HISTORY.BY_INVENTAIRE(inventaireId.toString()));
  }

  /**
   * Get single history record by ID
   */
  async getHistoryById(id: number): Promise<HistoryResponse> {
    return this.get<HistoryResponse>(ENDPOINTS.HISTORY.BY_ID(id.toString()));
  }

  /**
   * Create new history record
   */
  async createHistory(data: HistoryCreateInput): Promise<History> {
    const res = await this.post<HistoryResponse, HistoryCreateInput>('', data);
    return res.data;
  }

  /**
   * Delete history record by ID
   */
  async deleteHistory(id: number): Promise<HistoryResponse> {
    return this.delete<HistoryResponse>(ENDPOINTS.HISTORY.BY_ID(id.toString()));
  }
}
